module.exports = __webpack_public_path__ + "img/ph_instagram-logo-thin.90b36128.svg";